  // Format price based on instrument category
  export const fmtP = (value, category = 'forex') => {
    const num = Number(value);
    if (value === null || value === undefined || isNaN(num)) return '—';

    const precision = getPrecision(category);

    if (category === 'crypto' && num > 1000) {
      return '$' + num.toLocaleString('en-US', { maximumFractionDigits: 2 });
    }
    if (category === 'crypto') {
      return '$' + num.toFixed(4);
    }
    if (category === 'forex') {
      return num.toFixed(precision);
    }
    if (category === 'index') {
      return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
    }
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Get price precision based on category
  export const getPrecision = (category) => {
    switch (category) {
      case 'forex': return 5;
      case 'crypto': return 2;
      case 'metal': return 2;
      case 'stock': return 2;
      case 'index': return 2;
      case 'commodity': return 2;
      default: return 2;
    }
  };

  // Format USD currency
  export const fmtUSD = (value) => {
    const num = Number(value);
    if (value === null || value === undefined || isNaN(num)) return '$0.00';
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Format large volume numbers (K, M, B)
  export const fmtVolume = (value) => {
    const num = Number(value);
    if (!num || num === 0) return '—';
    if (num > 1e9) return (num / 1e9).toFixed(2) + 'B';
    if (num > 1e6) return (num / 1e6).toFixed(2) + 'M';
    if (num > 1e3) return (num / 1e3).toFixed(1) + 'K';
    return num.toFixed(0);
  };

  // Format percentage
  export const fmtPct = (value) => {
    const num = Number(value);
    if (value === null || value === undefined || isNaN(num)) return '—';
    const sign = num >= 0 ? '+' : '';
    return sign + num.toFixed(2) + '%';
  };

  // Format date
  export const fmtDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // Format time
  export const fmtTime = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  // Format datetime
  export const fmtDateTime = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  // Get CSS class for price change
  export const getChangeClass = (value) => {
    if (value > 0) return 'up';
    if (value < 0) return 'dn';
    return 'neu';
  };

  // Get CSS class for P&L
  export const getPnlClass = (value) => {
    if (value > 0) return 'pos';
    if (value < 0) return 'neg';
    return 'zero';
  };